export default {
  id: "rigged-champion",
  pride: 28672,
  slug: "rigged-champion",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "假赛拳王",
    en: "Rigged Champion"
  },
  image: "https://img.itch.zone/aW1nLzE0MTM5Nzk4LnBuZw==/315x250%23c/IGXOz4.png",
  descriptionKey: {
    zh: "Game Jam 合作游戏。水獭岛格斗大赛：冠军要负责管理小岛，亚军才能免费躺平。想办法故意输掉比赛！",
    en: "Game Jam collab. Otter Island Fighting Championship: the winner has to manage the island while the runner-up gets free residency. Try to lose on purpose!"
  },
  date: { year: 2023, month: 7, day: 9 },
  genres: ["格斗", "Game Jam"],
  themes: ["反套路", "水獭岛"],
  developerNotesKey: {
    zh: "和其他人一起在 Game Jam 上做的游戏。反套路格斗游戏：比赛冠军要负责管理水獭岛（每天干不完的杂活），亚军才能永久免费居住。想办法故意输！附赠1-bit迷你游戏。",
    en: "Made with others at a Game Jam. Anti-convention fighting game: the champion has to manage Otter Island (endless chores), while the runner-up gets permanent free residency. Your goal: intentionally lose! 1-bit mini game included."
  },
  tags: ["Game Jam"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "itch", url: "https://hecean.itch.io/rigged-champion", textKey: { zh: "itch.io 游玩", en: "Play on itch.io" } }
  ]
};
